import React from 'react'

function SecondaryBtn({ onClick, label, type, children, className }) {
  return (
    <button
      onClick={onClick}
      type={type || 'button'}
      className={
        className +
        ' tw-ms-3 tw-text-gray-500 tw-bg-white hover:tw-bg-gray-100 focus:tw-ring-4 focus:tw-outline-none focus:tw-ring-blue-300 tw-rounded-lg tw-border tw-border-gray-200 tw-text-regular tw-font-medium tw-px-[30px] tw-py-[7px] hover:tw-text-gray-900 focus:tw-z-10'
      }
    >
      {label || children}
    </button>
  )
}

export default SecondaryBtn
